const NEW_DRAFT_KEY = "__new__";

const pendingFilesByConversation = new Map<string, File[]>();

export const pendingComposerKey = (conversationId?: string | null) =>
  conversationId ?? NEW_DRAFT_KEY;

export const getPendingComposerFiles = (key: string): File[] =>
  pendingFilesByConversation.get(key) ?? [];

export const setPendingComposerFiles = (key: string, files: File[]) => {
  if (!files.length) {
    pendingFilesByConversation.delete(key);
    return;
  }
  pendingFilesByConversation.set(key, files);
};
